import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type TableBodyProps = ComponentProps<'tbody'>;

const TableBody = ({ className, ...props }: TableBodyProps) => {
  return (
    <tbody
      data-slot="table-body"
      className={cn('[&_tr:last-child]:border-0', className)}
      {...props}
    />
  );
};

export default TableBody;
